export default __webpack_public_path__ + "static/media/user-icon-color.38d32e15.svg";